<template>
  <div class="natural-comfort" data-position="1" data-name="自然舒适">
    <template v-if="isPC">
      <video
        ref="ncVideo"
        muted
        class="nc-bg-video"
        :src="VIDEO.naturalComfort"
      ></video>
      <div class="nc-text" :class="{ show: videoEnd }">
        <p class="nc-title ffm600">自然舒适</p>
        <p class="nc-content">
          我们把生活里的细节搬进了手机——光影的变化、交互的反馈、流畅的体验，<br />都像真实世界一样自然舒适。你不用刻意去适应，它都已经为你准备好了。
        </p>
      </div>
    </template>
    <template v-else>
      <div class="nc-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide slide1">
            <PlusImage class="title-img" :src="NATURAL_COMFORT.title" alt="" />
          </div>
          <div class="swiper-slide slide2">
            <PlusImage
              v-if="isPad"
              class="nc-bg-video"
              :src="NATURAL_COMFORT.padBg"
              alt=""
            />
            <PlusImage
              v-else
              class="nc-bg-video"
              :src="NATURAL_COMFORT.h5Bg"
              alt=""
            />
            <div class="nc-text" v-animate>
              <p class="nc-title ffm600">自然舒适</p>
              <p class="nc-content">
                我们把生活里的细节搬进了手机——光影的变化、交互<br />的反馈、流畅的体验，都像真实世界一样自然舒适。<br />
                你不用刻意去适应，它都已经为你准备好了。
              </p>
            </div>
          </div>
        </div>
        <div class="pagination">
          <div class="active" :class="{ right: activeIndex === 1 }"></div>
          <div class="btn-left" @click="slideTo(0)"></div>
          <div class="btn-right" @click="slideTo(1)"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { initExposureTrack } from "@/utils/track.js";
import { ScrollTrigger } from "@/utils/gsapConfig";
import VIDEO from "@/config/video";
import { NATURAL_COMFORT } from "@/config/image.js";
import "swiper/css";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
import observerManager from "@/utils/observerManager";

export default {
  name: "NaturalComfort",
  data() {
    return {
      VIDEO,
      NATURAL_COMFORT,
      videoEnd: false,
      activeIndex: 0,
    };
  },
  computed: {
    ...mapGetters(["isMobile", "isPad", "isPC"]),
  },
  mounted() {
    this.swiper = null;
    if (this.isPC) {
      this.video = this.$refs.ncVideo;
      this.initGsap();
      this.initEventListener();
    } else {
      this.initSwiper();
      this.initOberver();
    }
    initExposureTrack(".natural-comfort")();
  },
  methods: {
    initGsap() {
      if (!this.video) return;
      const that = this;
      this.fixScrollTrigger = ScrollTrigger.create({
        id: "ncfixScrollTrigger",
        trigger: ".natural-comfort",
        start: "top 100px", // 触发位置
        end: "bottom 100px", // 结束位置
        pin: true,
        // pinSpacing: false,
        scrub: true, // 使得元素滚动时，滚动速度等于页面滚动速度
        onEnter: () => {
          this.video.play();
          const duration = this.video.duration;
          const showTimer = setTimeout(() => {
            this.videoEnd = true;
            clearTimeout(showTimer);
          }, (duration - 1) * 1000);
        },
      });
    },
    initEventListener() {
      const that = this;
      $(window).on("scroll", function () {
        const windowScrollTop = $(window).scrollTop();
        if (windowScrollTop < 10) {
          that.videoEnd = false;
          that.video && (that.video.currentTime = 0);
        }
      });
    },
    initSwiper() {
      const that = this;
      this.swiper = new Swiper(".nc-swiper", {
        centeredSlides: true,
        // allowTouchMove: false,
        on: {
          slideChange: function (swiper) {
            that.activeIndex = swiper.activeIndex;
          },
        },
      });
    },
    initOberver() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: [0, 1],
      };
      observerManager.observe(
        this.$el,
        (isIntersecting, entry) => {
          if (!this.swiper) return;
          if (entry.intersectionRatio === 1) {
            setTimeout(() => {
              this.swiper.slideTo(1);
            }, 2000);
          } else if (
            entry.intersectionRatio === 0 &&
            $(window).scrollTop() < 10
          ) {
            this.swiper.slideTo(0);
          }
        },
        options
      );
    },
    slideTo(index) {
      this.swiper.slideTo(index);
    },
  },
};
</script>

<style scoped lang="scss">
.natural-comfort {
  width: 100%;
  height: 900 * $px1920vw + vw;
  position: relative;
  .nc-bg-video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    left: 0;
    top: 0;
  }
  .nc-text {
    opacity: 0;
    position: absolute;
    width: 100%;
    z-index: 1;
    top: 73 * $px1920vw + vw;
    left: 50%;
    transform: translateX(-50%) translateY(60px);
    transition: all ease-in-out 0.75s;
    color: #fff;
    .nc-title {
      font-size: 40 * $px1920vw + vw;
      line-height: 48 * $px1920vw + vw;
      letter-spacing: 0.1em;
    }
    .nc-content {
      font-size: 18 * $px1920vw + vw;
      line-height: 25.2 * $px1920vw + vw;
      margin-top: 18 * $px1920vw + vw;
    }
    &.show {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
}
.isPad {
  .natural-comfort {
    height: 340 * $px676vw + vw;
    .nc-swiper {
      width: 100%;
      height: 100%;
      position: relative;
      .slide1 {
        display: flex;
        align-items: center;
        justify-content: center;
        img,
        picture {
          width: 215 * $px676vw + vw;
          height: auto;
        }
      }
      .pagination {
        position: absolute;
        width: 120 * $px676vw + vw;
        height: 2 * $px676vw + vw;
        border-radius: 2 * $px676vw + vw;
        bottom: 8 * $px676vw + vw;
        left: 50%;
        transform: translateX(-50%);
        background: #e1e1e1;
        z-index: 2;

        .active {
          width: 50%;
          height: 100%;
          position: absolute;
          background: #707070;
          border-radius: 2 * $px676vw + vw;
          transition: transform 0.3s ease-in-out;
          &.right {
            transform: translateX(100%);
          }
        }
        .btn-left,
        .btn-right {
          position: absolute;
          bottom: -8 * $px676vw + vw;
          width: 50%;
          height: 42 * $px676vw + vw;
        }
        .btn-right {
          right: 0;
        }
      }
    }
    .nc-text {
      opacity: 1;
      left: 50%;
      width: 100%;
      top: 20 * $px676vw + vw;
      transform: translateX(-50%) translateY(0);
      .nc-title {
        font-size: 25 * $px676vw + vw;
        line-height: normal;
        letter-spacing: 0.1em;
      }
      .nc-content {
        font-size: 12 * $px676vw + vw;
        line-height: 14 * $px676vw + vw;
        margin-top: 8 * $px676vw + vw;
      }
    }
  }
}
.isMobile {
  .natural-comfort {
    height: 300 * $px360vw + vw;
    .nc-swiper {
      width: 100%;
      height: 100%;
      .slide1 {
        display: flex;
        align-items: center;
        justify-content: center;
        img,
        picture {
          width: 215 * $px360vw + vw;
          height: auto;
        }
      }
      .pagination {
        position: absolute;
        width: 120 * $px360vw + vw;
        height: 2 * $px360vw + vw;
        border-radius: 2 * $px360vw + vw;
        bottom: 8 * $px360vw + vw;
        left: 50%;
        transform: translateX(-50%);
        background: #e1e1e1;
        z-index: 2;

        .active {
          width: 50%;
          height: 100%;
          position: absolute;
          background: #707070;
          border-radius: 2 * $px360vw + vw;
          transition: transform 0.3s ease-in-out;
          &.right {
            transform: translateX(100%);
          }
        }
        .btn-left,
        .btn-right {
          position: absolute;
          bottom: -8 * $px360vw + vw;
          width: 50%;
          height: 42 * $px360vw + vw;
        }
        .btn-right {
          right: 0;
        }
      }
    }
    .nc-text {
      opacity: 1;
      width: 100%;
      top: 20 * $px360vw + vw;
      transform: translateX(-50%) translateY(0);
      .nc-title {
        font-size: 25 * $px360vw + vw;
        line-height: normal;
        letter-spacing: 0.1em;
      }
      .nc-content {
        font-size: 12 * $px360vw + vw;
        line-height: 14 * $px360vw + vw;
        margin-top: 8 * $px360vw + vw;
      }
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isPad,
  .isMobile {
    .natural-comfort {
      .nc-swiper {
        .slide1 {
          background: #000;
        }
      }
    }
  }
}
</style>
